import { render } from "./page-header.vue?vue&type=template&id=69c68d18&ts=true"
import script from "./page-header.vue?vue&type=script&lang=ts"
export * from "./page-header.vue?vue&type=script&lang=ts"

import "./page-header.vue?vue&type=style&index=0&id=69c68d18&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__